module.exports = __webpack_public_path__ + "static/media/ost_15.6d137902.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/ost_15.png
// module id = 1040
// module chunks = 0